import React from 'react';
import {createPortal} from 'react-dom';

import {Button, Notification} from '@ergeon/core-components';

import {SignInProgress} from './useSignInKeepingEdits';

type SessionExpiredNoticeProps = {
  signInProgress: SignInProgress;
  onAuth(): void;
  onDismiss(): void;
};

const COPY: Record<SignInProgress, {message: string; action: string}> = {
  idle: {message: 'Sign in again to keep working.', action: 'Sign in'},
  'keeping-edits': {message: 'Sign in again to keep working.', action: 'Saving your edits…'},
  'edits-at-risk': {
    message: 'Your latest edits could not be kept on this device. Signing in now may lose them.',
    action: 'Sign in anyway',
  },
};

function SessionExpiredNotice({signInProgress, onAuth, onDismiss}: SessionExpiredNoticeProps) {
  const {message, action} = COPY[signInProgress];
  const isKeepingEdits = signInProgress === 'keeping-edits';

  return createPortal(
    <div className="fixed bottom-4 left-4 z-1000 w-80" role="alert">
      <Notification data-testid="session-expired-notice" flavor="primary" mode="floating" onClose={onDismiss}>
        <h6 className="text-gray-900 dark:text-white heading-6">Session expired</h6>
        <p className="text-gray-700 dark:text-gray-300 paragraph-2 wrap-break-word max-w-full">{message}</p>
        <div>
          <Button disabled={isKeepingEdits} onClick={onAuth} size="small">
            {action}
          </Button>
        </div>
      </Notification>
    </div>,
    document.body,
  );
}

export default SessionExpiredNotice;
